<template>
  <Modal v-model="modalValue" :title="isEdit ? `编辑证书` : '新增证书'" width="800" @on-cancel="modalCancel">
    <Row class="row">
      <Col span="20" offset="1">
        <Form ref="addForm" :model="form" :rules="rules" :label-width="100">
          <div class="tag-title">基础信息</div>
          <FormItem label="证书名称" prop="title">
            <Input placeholder="请输入证书名称" v-model="form.title"></Input>
          </FormItem>
          <FormItem label="证书状态" prop="status">
            <RadioGroup v-model="form.status">
              <Radio label="1">有效</Radio>
              <Radio label="0">无效</Radio>
            </RadioGroup>
          </FormItem>
          <div class="tag-title">
            字段信息
            <span style="font-size: 10px; font-weight: 400">(*拖动字段名实现排序)</span>
          </div>
          <vue-draggable v-model="form.fields">
            <FormItem v-for="(item, index) in form.fields" :key="index" :label="`字段${index + 1}`">
              <div class="formItem" >
                <Button readonly :disabled="item.is_default == 1">{{ item.title }}</Button>
              <a style="color: red; margin-left: 10px" v-if="item.is_default != 1" @click="deleteField(index)">删除</a>
              </div>
            </FormItem>
          </vue-draggable>
          <FormItem>
            <Button type="primary" icon="ios-add" @click="diyDom.showModal = true">添加字段</Button>
          </FormItem>
        </Form>
      </Col>
    </Row>
    <div slot="footer">
      <Button @click="modalCancel">取消</Button>
      <Button type="primary" :loading="btnLoading" @click="modalConfirm">确认</Button>
    </div>
    <license-field
      v-model="diyDom.showModal"
      :list="form.fields"
      :type="2"
      @on-change="customFieldChange"
    ></license-field>
  </Modal>
</template>

<script>
  import _ from 'lodash'
  import licenseField from './license-field/license-field.vue'
  import vueDraggable from 'vuedraggable'
  import * as apiCertificates from '@/api/certificates'
  export default {
    components: {
      licenseField,
      vueDraggable,
    },
    name: 'add-license',
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      isEdit: {
        type: Boolean,
        default: false,
      },
      id: {
        type: [String, Number],
        default: '',
      },
      defaultFields: {
        type: [Array],
      },
    },
    data() {
      return {
        btnLoading:false,
        diyDom: {
          showModal: false, // 选择字段
        },
        form: {
          title: '',
          status: '1',
          fields: [], // 自定义字段
        },
        rules: {
          title: [{ required: true, message: '证书名称不能为空', trigger: 'blur' }],
          status: [{ required: true, message: '证书状态不能为空', trigger: 'blur' }],
        },
      }
    },
    methods: {
      // 获取详情
      getDetail() {
        apiCertificates.apiCertificatesDetail(this.id).then(res => {
          const {data} = res
          this.form.title = data.title
          this.form.status = data.status + ''
          this.form.fields = data.fields
        })
      },
      // 提交
      modalConfirm() {
        this.$refs['addForm'].validate(valid => {
          if (valid) {
            this.btnLoading = true
            let opt = _.cloneDeep(this.form)
            opt.fields = opt.fields.map((item, index) => {
              return {
                id:item.id,
                is_default:item.is_default,
                title:item.title,
                sort: index,
              }
            })
            if (this.isEdit) {
              apiCertificates.apiCertificatesEdit(this.id,opt).then(res => {
                this.$Message.success('编辑证书成功')
                this.$emit('on-success')
                this.modalCancel()
              }).finally(()=>this.btnLoading = false)
            } else {
              apiCertificates.apiCertificatesAdd(opt).then(res => {
                this.$Message.success('新增证书成功')
                this.$emit('on-success')
                this.modalCancel()
              }).finally(()=>this.btnLoading = false)
            }
          }
        })
      },
      // 删除字段
      deleteField(index) {
        this.form.fields.splice(index,1)
      },
      modalCancel() {
        this.$refs['addForm'].resetFields()
        this.form.fields = []
        this.$nextTick(() => {
          this.modalValue = false
        })
      },
      // 字段改变
      customFieldChange(data) {
        this.form.fields = data
      },
    },
    computed: {
      modalValue: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit('input', val)
        },
      },
    },
    watch: {
      value(val) {
        if (val && this.isEdit) {
          this.getDetail()
        }
        if (!this.isEdit) {
          this.form.fields = this.defaultFields
        }
      },
    },
  }
</script>

<style scoped lang="less">
  .row {
    max-height: 600px;
    overflow-y: auto;
  }
  .formItem {
    border-radius: 5px;
    border: 1px dashed #c5c5c5;
    padding: 10px 15px;
    margin-bottom: 10px;
    cursor: pointer;
  }
</style>
